"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableAddress = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var format_street_address_1 = require("../../lib/format-street-address");
function SelectableAddress(props) {
    var _a = props.isActive, isActive = _a === void 0 ? false : _a, onChange = props.onChange, candidate = props.candidate, enteredAddress = props.enteredAddress;
    var value = '';
    if (candidate) {
        var formattedAddress = format_street_address_1.formatCandidateToAddress(candidate).formattedAddress;
        value = formattedAddress;
    }
    if (enteredAddress) {
        value = enteredAddress.formattedAddress;
    }
    var handleChange = function (e) {
        e.preventDefault();
        if (onChange)
            onChange(value);
    };
    var handleKeyDown = function (e) {
        if (e.key === ' ') {
            if (onChange)
                onChange(value);
        }
    };
    /**
     * getVerificationStatus
     * render a status message for Partial and Ambigious statuses only
     * (Unverified results won't make it to this component)
     * @param verificationStatus
     * @returns
     */
    function getVerificationStatus(verificationStatus) {
        if (verificationStatus === 'Verified')
            return;
        return (react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center" },
            react_1.default.createElement(core_ui_1.IconWarning, { color: verificationStatus !== 'None' ? core_ui_1.colors.peach[500] : undefined, size: 12 }),
            react_1.default.createElement(core_ui_1.Spacing, { width: 4 }),
            react_1.default.createElement(core_ui_1.Text, { size: "small", color: core_ui_1.colors.steel[400] }, "Only some parts of this address were verified")));
    }
    return (react_1.default.createElement(StyledRow, { className: isActive ? 'active' : '', onClick: handleChange, onKeyDown: handleKeyDown, tabIndex: 0, role: "checkbox" },
        react_1.default.createElement(core_ui_1.Padding, { y: 12 },
            react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "center", justifyContent: "space-between" },
                react_1.default.createElement(core_ui_1.Flexbox, { alignItems: "flex-start" },
                    react_1.default.createElement(core_ui_1.Padding, { right: 16 },
                        react_1.default.createElement(StyledIconWrapper, null, isActive ? react_1.default.createElement(core_ui_1.IconTick, null) : false)),
                    react_1.default.createElement(core_ui_1.Stack, { gap: 4, direction: "vertical" },
                        value && react_1.default.createElement(core_ui_1.Text, { weight: 600 }, value),
                        candidate && getVerificationStatus(candidate.analysis.verificationStatus)))))));
}
exports.SelectableAddress = SelectableAddress;
var StyledRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var StyledIconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid ", ";\n  border-radius: 100%;\n  display: flex;\n  height: 20px;\n  justify-content: center;\n  width: 20px;\n\n  .active & {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"], ["\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid ", ";\n  border-radius: 100%;\n  display: flex;\n  height: 20px;\n  justify-content: center;\n  width: 20px;\n\n  .active & {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), core_ui_1.colors.steel[200], core_ui_1.colors.brand[400], core_ui_1.colors.brand[400]);
var templateObject_1, templateObject_2;
